import { BrowserRouter } from 'react-router-dom';
import { StoreProvider } from '../app/providers/StoreProvider';
import { TelegramProvider } from './providers/TelegramProvider';
import { AuthProvider } from '../app/providers/AuthProvider';
import { AppRouter } from './router';
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NavMenu from '../components/NavMenu/NavMenu';
import BalanceTop from '../components/BalanceTop/BalanceTop';
import { TadsWidgetProvider } from 'react-tads-widget';
import NotificationWrapper from '../components/Notifications/NotificationWrapper';
import { TransitionProvider } from './providers/TransitionProvider';
import FriendsPageBackground from '../assets/backgrounds/FriendsPageBackground.webp';
import LeaderboardBackground from '../assets/backgrounds/LeaderboardBackground.webp';
import ProfilePageBackground from '../assets/backgrounds/ProfilePageBackground.webp';
import TasksPageBackground from '../assets/backgrounds/TasksPageBackground.webp';
import { usePreloadImages } from '../utils/usePreloadImages';

const AppContent: React.FC = () => {

  usePreloadImages([FriendsPageBackground, LeaderboardBackground, ProfilePageBackground, TasksPageBackground])

  const loc = useLocation();
  useLayoutEffect(() => {
    if (loc.pathname === '/') {
      document.body.classList.add('main-page');
      document.body.classList.remove('tasks-page');
    } else if (loc.pathname === '/tasks') {
      document.body.classList.add('tasks-page');
      document.body.classList.remove('main-page');
    } else {
      document.body.classList.remove('main-page', 'tasks-page');
    }
  }, [loc.pathname]);

  // if (showStartScreen) {
  //   return <StartScreen onOpen={handleOpen} />;
  // }

  return (
    <>
      {/* <BalanceTop /> */}
      <AppRouter />
      <NavMenu />
    </>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <TadsWidgetProvider>
        <TelegramProvider>
          <StoreProvider>
            <AuthProvider>
              <TransitionProvider>
                <AppContent />
              </TransitionProvider>
              <NotificationWrapper />
            </AuthProvider>
          </StoreProvider>
        </TelegramProvider>
      </TadsWidgetProvider>
    </BrowserRouter>
  );
};

export default App;
